export const MESSAGING_ACCESS = 'messaging-access';